import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import { BrowserRouter as Router } from "react-router-dom"
import { GlobalContextProvider } from "./context/GlobalContext"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { CartContextProvider } from "./context/CartContext"
import { ProductsContextProvider } from "./context/ProductsContext"

const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <QueryClientProvider client={queryClient}>
    <GlobalContextProvider>
      <ProductsContextProvider>
        <CartContextProvider>
          <Router>
            <App />
          </Router>
        </CartContextProvider>
      </ProductsContextProvider>
    </GlobalContextProvider>
  </QueryClientProvider>
)
